import { ICustomRouteConfig } from "@/store/interface/custom.route.config.interface";
import { RouteConfig } from "vue-router";

/**
 * Copies the `permission` and `isStandaloneLayout` properties from ICustomRouteConfig into
 * `meta`, so that they are available in navigation guards via `to.meta.permission` and when
 * rendering the route via `$route.meta.isStandaloneLayout`.
 *
 * Vue Router 3 does not propagate custom RouteConfig properties to `to.meta`,
 * only the `meta` field is preserved. This function bridges that gap.
 *
 * Mutates routes in-place and handles children recursively.
 */
export function enrichRouteMeta(routes: ICustomRouteConfig[]): RouteConfig[] {
  for (const route of routes) {
    const permission = route.permission;

    if (permission) {
      if (!route.meta) {
        route.meta = {};
      }
      route.meta.permission = permission;
    }

    if (route.isStandaloneLayout) {
      if (!route.meta) {
        route.meta = {};
      }
      route.meta.isStandaloneLayout = true;
    }

    if (route.children) {
      enrichRouteMeta(route.children);
    }
  }

  return routes;
}
